/**
 * @generated SignedSource<<09ebed6e86c5a679f42429cb61ae4547>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserBalance_balance$data = {
  readonly amount: {
    readonly currency: string;
    readonly formatted: string;
    readonly subUnitAmount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "UserBalance_balance";
};
export type UserBalance_balance$key = {
  readonly " $data"?: UserBalance_balance$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserBalance_balance">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./UserBalanceRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "UserBalance_balance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "WalletBalance",
  "abstractKey": null
};

(node as any).hash = "3424bd3ea88adcb2a83bae5cf8c50218";

export default node;
